export class ReceivedFileDTO{
    public id!: number;
    public name!: string;
    public customerId!: number;
    public userId!: number;
    public interfaceType!: number;
    public sourceIP!: string;
    public status!: number;
    public moovDefinitionId!: number;
    public moovDefinitionName!: string;
    public moovConfigurationId!: number;
    public moovInstanceId!: number;
    public filepath!: string;
    public added!: string;
    public externalUploaderName!: string; //used for external file upload
    public externalUploaderEmail!: string; //used for external file upload
    public purgeAfter!: string;
    public purgedAt!: string;

}